import { GamingFromStrategyIcon } from '@/svgs'
import React from 'react'

function GamingFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Vision to Victory: Our Gaming & Sports Software Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of experience in game and sports software development, we create flawless, scalable, and high-performing solutions. Our systematic methodology maximizes player engagement, fine-tunes gameplay mechanics, and accelerates interactive experiences.
            </p>

            <GamingFromStrategyIcon />
         </div>
      </section>
   )
}

export default GamingFromStrategy
